module.exports = "2eeb8265a99ad98a7002e02f5d940105.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/button_click.wav
// module id = 95
// module chunks = 0